import { API_URL } from 'constants/routes';

import { fetcher, CancelTokenSource } from 'api_entities/fetch';

import type { GeneralSearch } from './types';

export const generalSearchApi = {
  getGeneralSearch: async function (params: URLSearchParams, cancelToken: CancelTokenSource) {
    const { data } = await fetcher.get<GeneralSearch>(API_URL.SEARCH, {
      params,
      cancelToken: cancelToken.token,
    });
    return data;
  },
};
